import { render, staticRenderFns } from "./Ads.vue?vue&type=template&id=64186c30&scoped=true"
import script from "./Ads.vue?vue&type=script&lang=js"
export * from "./Ads.vue?vue&type=script&lang=js"
import style0 from "./Ads.vue?vue&type=style&index=0&id=64186c30&prod&lang=scss&scoped=true"
import style1 from "./Ads.vue?vue&type=style&index=1&id=64186c30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64186c30",
  null
  
)

export default component.exports